import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'components.Payment.title',
    defaultMessage: 'Pay & Confirm',
  },
  continue: {
    id: 'components.Payment.continue',
    defaultMessage: 'Continue to payment',
  },
  back: {
    id: 'components.Payment.back',
    defaultMessage: 'Back to review order',
  },
  paymentError: {
    id: 'errors.payment.error',
    defaultMessage:
      'There was an error during payment. Please try a different payment method.',
  },
  requiredValidationError: {
    id: 'common.titles.validationError',
    defaultMessage: '{field} is required.',
  },
  paymentMethodRequiredError: {
    id: 'common.titles.payment',
    defaultMessage: 'Payment',
  },
  alertErrorTitle: {
    id: 'components.alerts.error',
    defaultMessage: 'Error',
  },
  paymentFailedErrorTitle: {
    id: 'shop.payment.paymentFailedErrorTitle',
    defaultMessage: 'Payment Error',
  },
  paymentFailedErrorMessage: {
    id: 'shop.payment.paymentFailedErrorMessage',
    defaultMessage:
      'Your payment could not be processed. Please check your credit card information or select another payment method',
  },
});
